import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { TRIP_GET_ONE } from 'api/query-keys.ts';
import type { TGetTripRes } from 'api/swagger';

export const useGetTrip = (id?: number) => {
  return useQuery<TGetTripRes>({
    queryKey: [TRIP_GET_ONE, id],
    queryFn: async () => {
      const { data } = await http.get<TGetTripRes>(`/v1/trips/${id}`);
      return data;
    },
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: 10 * 1000,
    cacheTime: 20 * 1000,
    enabled: !!id,
  });
};
